import { render, staticRenderFns } from "./SpaceManagementDialog.vue?vue&type=template&id=9642de0a&scoped=true"
import script from "./SpaceManagementDialog.vue?vue&type=script&lang=js"
export * from "./SpaceManagementDialog.vue?vue&type=script&lang=js"
import style0 from "./SpaceManagementDialog.vue?vue&type=style&index=0&id=9642de0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9642de0a",
  null
  
)

export default component.exports